export default "__VITE_ASSET__DquTY0AQ__"